import { useTranslation } from 'react-i18next';
import { Preloader } from '@/components/Preloader';
import { useModal } from '@/providers/modal';
import { MODAL_IDS } from '@/kit/Modal/keys';
import { useWindowSize } from '@/hooks/useWindowSize';
import { ModalSwipeLayout } from '@/kit/Modal/layouts/swipe';
import { ModalCenterLayout } from '@/kit/Modal/layouts/center';
import { useGetBrandDetailBySlug } from '@/query/queries/brand/useGetBrandDetailBySlug';
import { BrandDetail } from '../BrandDetail';
import s from './index.module.scss';

const id = MODAL_IDS.brand_detail_modal;

export const BrandDetailModal = () => {
  const { modalIds, data } = useModal();
  return modalIds[id] && data && <Modal brandSlug={data} />;
};

export const Modal = ({ brandSlug }) => {
  const { t } = useTranslation('modal');
  const {
    data: brand,
    isLoading,
    isFetching,
  } = useGetBrandDetailBySlug(brandSlug);
  const { isMobile } = useWindowSize();
  const { closeModal } = useModal();

  const loading = isLoading || isFetching;

  const content = (
    <div className={s.modal}>
      {loading ? (
        <Preloader className={s.preloader} />
      ) : brand ? (
        <div className={s.content}>
          <BrandDetail brand={brand} />
        </div>
      ) : (
        <div>{t('company_modal.error_message')}</div>
      )}
    </div>
  );

  return isMobile ? (
    <ModalSwipeLayout id={id} onClose={() => closeModal(id)} showClose>
      {content}
    </ModalSwipeLayout>
  ) : (
    <ModalCenterLayout id={id} onClose={() => closeModal(id)} showClose>
      {content}
    </ModalCenterLayout>
  );
};
